import React, { ReactElement } from 'react';

import './TyreIndexCard.scss';

interface Props {
  cardData: {
    cardImg: {
      url: string;
      alternativeText: string;
    };
    id: string;
    cardTitle: string;
    cardText: string;
    cardLink: string;
  };
}

const TyreIndexCard = (props: Props): ReactElement => {
  const { cardTitle, cardLink, cardImg, cardText } = props.cardData;

  return (
    <>
      <li className="tyreCard">
        <a className="cardLink" href={cardLink}>
          <img
            className="tyreIndexImg"
            src={cardImg.url}
            alt={cardImg.alternativeText}
          />
          <div className="cardText">
            <h5>{cardTitle}</h5>
            <p className="introText">{cardText}</p>
          </div>
        </a>
      </li>
    </>
  );
};

export default TyreIndexCard;
